
import React from 'react';
//import { BsLinkedin, BsGithub } from 'react-icons/bs';

const SocialMedia = () => {
  return (
    <div className="app__social">
        
    </div>
  )
}

export default SocialMedia

/*
<div className="linked" onClick={() => { window.location.assign('https://www.linkedin.com/in/filip-n-881815261/')}}>
            <BsLinkedin />
        </div>
        <div className="git" onClick={() => { window.location.assign('https://github.com/filipInSpace')}}>
            <BsGithub />
        </div>
*/
